import React, { useState } from 'react'
import { makeStyles } from '@material-ui/core/styles'
import { Wizard } from 'react-use-wizard'
import { SelectRole } from './steps/select-role/select-role'
import { UserCredentials } from './steps/user-credentials/user-credentials'
import { Modal } from '../../../root/components/common'
import { Header } from './header/header'
import { NewUserLocations } from './steps/locations/new-user-locations'
import { Review } from './steps/review/review'
import { useDispatch, useSelector } from 'react-redux'
import { craeteUser } from '../../api/api'
import { enqueueSnackbar } from 'web/src/app/root/actions'
import { UserRelation } from './steps/user-relation/user-relation'
import {
    CreateUserProvider,
    useCreateUser
} from './context/create-user-context'
import { USER_RELATIONS } from 'web/src/app/root/constants'
import { useRoles } from '../../../root/hooks/use-roles'
import { useLocation, useHistory } from 'react-router-dom'
import { useEffect } from 'react'

const CreateUser = props => {
    const {
        onClose,
        modalProps: { open }
    } = props
    const styles = useStyles()
    const { userState, resetUserState, userRelation, onUserUpdate } =
        useCreateUser()
    const { original_customer_id } = useSelector(state => state.main.user)
    const { locale } = useSelector(state => state.main)
    const dispatch = useDispatch()
    const location = useLocation()
    const history = useHistory()
    const returnUrl = new URLSearchParams(location.search).get('returnUrl')
    const initialEmail = new URLSearchParams(location.search).get('email')
    const { defaultRoles, isLoadingRoles, isRolesError } = useRoles()
    const [isSubmitted, setIsSubmitted] = useState(false)

    const onModalClose = (returnUrl, email) => {
        resetUserState()
        onClose()
        if (returnUrl && email) {
            history.push(`${returnUrl}&email=${email}`)
        }
    }

    const handleSubmit = () => {
        setIsSubmitted(true)
        const { customer_name, ...restState } = userState
        delete restState.lastName
        const submitState = {
            ...restState,
            ...(customer_name
                ? { customer_name }
                : { customer_id: original_customer_id })
        }

        craeteUser(submitState)
            .then(() => {
                dispatch(
                    enqueueSnackbar({
                        message: locale.sagasMsgs.createUserRes,
                        options: {
                            variant: 'success'
                        }
                    })
                )
                onModalClose(returnUrl, submitState.email)
                setIsSubmitted(false)
            })
            .catch(e => {
                dispatch(
                    enqueueSnackbar({
                        message: locale.sagasMsgs.createUserEx,
                        options: {
                            variant: 'error'
                        }
                    })
                )
                setIsSubmitted(false)
            })
    }
    const getModalTitle = relation =>
        relation
            ? relation === USER_RELATIONS.internal
                ? locale.userManagement.createInternalTitle
                : locale.userManagement.createExternalTitle
            : locale.userManagement.createUserModalTitle

    useEffect(() => {
        if (initialEmail) {
            onUserUpdate({ email: initialEmail })
        }
    }, [initialEmail])
    return (
        <Modal
            size="xl"
            className={styles.modal}
            onClose={onModalClose.bind(this, returnUrl, initialEmail)}
            open={open}>
            <div className={styles.root}>
                <Wizard
                    header={
                        <Header
                            onClose={onModalClose.bind(
                                this,
                                returnUrl,
                                initialEmail
                            )}
                            // title={getModalTitle(userRelation)}
                        />
                    }>
                    <UserRelation />
                    <UserCredentials />
                    <SelectRole
                        defaultRoles={defaultRoles}
                        isLoadingRoles={isLoadingRoles}
                        isRolesError={isRolesError}
                    />
                    <NewUserLocations />
                    <Review onSubmit={handleSubmit} isSubmitted={isSubmitted} />
                </Wizard>
            </div>
        </Modal>
    )
}

export const CreateUserModal = props => {
    const isFromLocationAssignment = new URLSearchParams(location.search).get(
        'isFLA'
    )
    return (
        <CreateUserProvider
            isFromLocationAssignment={isFromLocationAssignment === 'true'}>
            <CreateUser {...props} />
        </CreateUserProvider>
    )
}

const useStyles = makeStyles(theme => ({
    root: {
        minHeight: '90vh',
        maxHeight: '90vh',
        overflowY: 'auto',
        display: 'flex',
        flexDirection: 'column'
    },
    modal: {
        padding: 0
    }
}))
